import envConfig from 'config.env';

const MANDATORY_SEARCH_PARAMS = ['solutions', 'fteFrom', 'fteTo'];
const OPTIONAL_SEARCH_PARAMS = ['postcode', 'location', 'coverage', 'isProductLink'];
const DIRECT_LINK_SEARCH_PARAMS = ['solutions'];
const SEARCH_PARAMS = [
  ...MANDATORY_SEARCH_PARAMS,
  ...OPTIONAL_SEARCH_PARAMS
];
const ACT_PREFIX = '26';
const NT_PREFIX = '08';

const ExpertFinderConstants = angular
  .module('constants.expertFinder', [])
  .constant('ACT_POSTCODE_PREFIX', ACT_PREFIX)
  .constant('NT_POSTCODE_PREFIX', NT_PREFIX)
  .constant('MANDATORY_SEARCH_PARAMS', MANDATORY_SEARCH_PARAMS)
  .constant('OPTIONAL_SEARCH_PARAMS', OPTIONAL_SEARCH_PARAMS)
  .constant('DIRECT_LINK_SEARCH_PARAMS', DIRECT_LINK_SEARCH_PARAMS)
  .constant('SEARCH_PARAMS', SEARCH_PARAMS)
  .constant('AppConfig', envConfig);

export default ExpertFinderConstants;



// WEBPACK FOOTER //
// ./src/constants.js